import name from './name'

const selectSliceData = state => state[name]
const selectPlaylistId = state => selectSliceData(state)

export { selectPlaylistId }
